import React, { useEffect, useState } from 'react';
import { FaArrowRight, FaArrowLeft } from 'react-icons/fa';
import { HiDotsHorizontal } from 'react-icons/hi';
import { FaRegEdit } from 'react-icons/fa';
import { MdDeleteOutline } from 'react-icons/md';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import {
  DeleteOrganization,
  GetOneOrganization,
  LoadOrganization,
  ResetOrganization,
  _GetOneOrganization,
  updateRole,
} from '../../Redux/OrganizationSlice';
import { api } from '../../Api-Endpoints/apiEndpoint';
import EditOrganizationModal from '../Modal/EditOrganizationModal';
import { BsEyeFill } from 'react-icons/bs';
import Modal from 'react-modal';
import toast from 'react-hot-toast';
import DeleteModal from '../Modal/DeleteModal';
const OrganizationTable = ({ filtered }) => {
  const dispatch = useDispatch();
  const { organizations, organization, isOrg, isRoleUpdated } = useSelector(
    state => ({
      organizations: state.Organization.organizations,
      organization: state.Organization.organization,
      isOrg: state.Organization.isOrg,
      isRoleUpdated: state.Organization.isRoleUpdated,
    }),
    shallowEqual
  );
  const [SelectedOrganizationIndex, setSelectedOrganizationIndex] =
    useState(null);
  const [showModal, setShowModal] = useState(false);
  const [arrowDown, setArrowDown] = useState(false);
  const [isOpenUserModel, setIsOpenUserModel] = useState(false);
  const [ids, setIds] = useState('');
  const [org, setOrg] = useState({});
  const [hoveredIndex, setHoveredIndex] = useState(null);
  useEffect(() => {
    if (isOrg) {
      // const _org = organizations.find((o) => o._id == id);
      const users = organization.users.map(u => ({
        ...u,
        isEditMode: false,
      }));
      setOrg({
        _id: organization._id,
        name: organization.name,
        users,
        procedures: organization.procedures,
        isOpen: false,
        isDown: false,
      });
      dispatch(ResetOrganization());
    }
    if (isRoleUpdated) {
      const users = organization.users.map(u => ({
        ...u,
        isEditMode: false,
      }));
      setOrg({
        _id: organization._id,
        name: organization.name,
        users,
        procedures: organization.procedures,
        isOpen: false,
        isDown: false,
      });
      // setOrg((prev) => ({
      //   ...prev,
      //   users: prev.users.map((u) =>
      //     u._id == ids ? { ...u, isEditMode: false } : { ...u }
      //   ),
      // }));
      dispatch(ResetOrganization());
    }
  }, [isOrg, isRoleUpdated, organization]);

  const handleToggle = index => {
    setSelectedOrganizationIndex(
      index === SelectedOrganizationIndex ? null : index
    );
  };

  const onEditOrganization = id => {
    dispatch(GetOneOrganization(id));
    setSelectedOrganizationIndex(null);
    setShowModal(true);
  };

  const onOpenUserModel = id => {
    dispatch(_GetOneOrganization(id));
    setIsOpenUserModel(true);
  };
  const onEdit = id => {
    setIds(id);
    setOrg(prev => ({
      ...prev,
      users: prev.users.map(u =>
        u._id == id ? { ...u, isEditMode: true } : { ...u }
      ),
    }));
  };
  const onSubmitEdit = async (orgId, userId, newPrevilliages) => {
    try {
      const { status, data } = await api.patch(`/org/update-role/${orgId}`, {
        userId,
        newPrevilliages,
      });
      if (status == 201) {
        dispatch(updateRole(data._org));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onAssignRole = async e => {
    const { checked, name, value } = e.target;
    const [userId, ...rest] = value.split('-');
    const proId = rest.join('-');
    if (checked) {
      let users = [];
      users.push(userId);
      const { status, data } = await api.patch(
        `/procedure/user-assigned/${proId}`,
        { users }
      );
      if (status == 201) {
        alert('done');
      }
    }
  };
  const removeDuplicatesAndCount = roles => {
    const removalCounts = {};

    roles.forEach(role => {
      const seenProcedures = new Set();
      role.procedures = role.procedures.filter(proc => {
        if (seenProcedures.has(proc.procedure.name)) {
          if (!removalCounts[proc.procedure.name]) {
            removalCounts[proc.procedure.name] = 0;
          }
          removalCounts[proc.procedure.name]++;
          return false;
        } else {
          seenProcedures.add(proc.procedure.name);
          return true;
        }
      });
    });
    console.log(removalCounts);
    // return removalCounts;
  };

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selected, setSelected] = useState('');

  const confirmDeleteModal = async id => {
    setSelected(id);
    setShowDeleteModal(true);
    setSelectedOrganizationIndex(null);
  };

  const confirmDelete = async () => {
    handleDeleteOrg(selected);
  };
  const handleDeleteOrg = async _id => {
    try {
      const { status, data } = await api.get(`/org/org-delete/${_id}`);
      if (status == 200) {
        await dispatch(DeleteOrganization(_id));
        toast.success('Organization deleted successfully');
      }
    } catch (error) {
      console.log(error.message);
    }
  };
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15; // Number of items per page

  const totalPages = Math.ceil(organizations?.length / itemsPerPage);

  // Get items for the current page
  const paginatedData = organizations.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  // Handle next and previous page
  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prev => prev + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => prev - 1);
    }
  };
  return (
    <>
      <div className="w-full bg-white border border-gray-300 rounded-2xl overflow-hidden">
        <table className="w-full px-10">
          <thead className="bg-gray-200 h-12 text-left">
            <tr>
              <th className="ps-5">S. NO.</th>
              <th>Organization Name</th>
              <th>Organization Code</th>
              <th>Role Assigned</th>
              {/* <th>Procedures Assigned</th> */}
              <th>External Users Assigned</th>
              <th>Date Created</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody className="text-left">
            {paginatedData.length == 0 ? (
              paginatedData.map(
                (organization, index) => (
                  console.log(organization, 'checkkk'),
                  (
                    <tr key={index} className="h-[6vh] border-b">
                      <td className="ps-5">{index + 1}</td>
                      <td>{organization.name}</td>
                      <td>{organization?.code}</td>
                      <td>{organization?._roles?.length}</td>
                      <td className="flex gap-2 justify-start items-center p-5">
                        {organization?.users?.length}{' '}
                        <BsEyeFill
                          className="text-red-500 cursor-pointer"
                          onClick={() => onOpenUserModel(organization._id)}
                        />
                      </td>
                      <td>{new Date(organization.createdAt).toDateString()}</td>
                      <td className="relative">
                        <div
                          onMouseEnter={() => setHoveredIndex(index)}
                          onMouseLeave={() => setHoveredIndex(null)}
                        >
                          <HiDotsHorizontal
                            size={30}
                            className="cursor-pointer"
                          />
                          {hoveredIndex === index && (
                            <div className="bg-gray-200 absolute top-10 right-20 border border-gray-300 p-5 rounded-xl z-20 space-y-2">
                              <div
                                onClick={() =>
                                  onEditOrganization(organization?._id)
                                }
                                className="flex items-center gap-5 cursor-pointer"
                              >
                                <FaRegEdit size={12} />
                                <p>Edit</p>
                              </div>
                              <div
                                onClick={() =>
                                  confirmDeleteModal(organization?._id)
                                }
                                className="flex items-center gap-5 cursor-pointer"
                              >
                                <MdDeleteOutline size={15} />
                                <p>Delete</p>
                              </div>
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                  )
                )
              )
            ) : (
              <>
                {paginatedData.map((organization, index) => (
                  <tr key={index} className="h-[6vh] border-b">
                    <td className="ps-5">{index + 1}</td>
                    <td>{organization.name}</td>
                    <td>{organization?.code}</td>
                    <td>{organization?._roles?.length}</td>
                    <td>{organization?.users?.length}</td>
                    <td>{new Date(organization.createdAt).toDateString()}</td>
                    <td className="relative">
                      <div
                        onMouseEnter={() => setHoveredIndex(index)}
                        onMouseLeave={() => setHoveredIndex(null)}
                      >
                        <HiDotsHorizontal
                          size={30}
                          className="cursor-pointer"
                        />
                        {hoveredIndex === index && (
                          <div className="bg-gray-200 absolute top-10 right-20 border border-gray-300 p-5 rounded-xl z-20 space-y-2">
                            <div
                              onClick={() =>
                                onEditOrganization(organization?._id)
                              }
                              className="flex items-center gap-5 cursor-pointer"
                            >
                              <FaRegEdit size={12} />
                              <p>Edit</p>
                            </div>
                            <div
                              onClick={() =>
                                confirmDeleteModal(organization?._id)
                              }
                              className="flex items-center gap-5 cursor-pointer"
                            >
                              <MdDeleteOutline size={15} />
                              <p>Delete</p>
                            </div>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </>
            )}
          </tbody>
        </table>

        {/* {console.log(org)} */}
        <div className="my-5 flex justify-between items-center px-16 py-4">
          <button
            onClick={handlePrevious}
            disabled={currentPage === 1}
            className={`flex items-center space-x-3 ${
              currentPage === 1 ? 'opacity-50 cursor-not-allowed' : ''
            }`}
          >
            <FaArrowLeft />
            <span>Prev</span>
          </button>
          <span className="font-semibold">
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={handleNext}
            disabled={currentPage === totalPages}
            className={`flex items-center space-x-3 ${
              currentPage === totalPages ? 'opacity-50 cursor-not-allowed' : ''
            }`}
          >
            <span>Next</span>
            <FaArrowRight />
          </button>
        </div>
        <EditOrganizationModal
          showModal={showModal}
          onClose={() => setShowModal(false)}
        />
      </div>

      <Modal
        isOpen={isOpenUserModel}
        onRequestClose={() => {
          setOrg({});
          setIsOpenUserModel(false);
        }}
        contentLabel="Example Modal"
        style={{
          content: {
            width: '50%',
            height: '52%',
            margin: 'auto',
            borderRadius: '20px',
            padding: 0,
          },
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
          },
        }}
      >
        <div className="h-[5vh] w-full p-2 flex justify-start items-center bg-gray-200">
          <h1>{org?.name}</h1>
        </div>
        <div className="flex flex-col h-[50vh] w-full p-2 overflow-y-scroll">
          <div className="flex h-[5vh] w-full border border-black rounded-md bg-gray-200">
            <div className="flex justify-center items-center h-[100%] w-[33%] ">
              No.#
            </div>
            <div className="flex justify-center items-center h-[100%] w-[33%] ">
              Name
            </div>
            <div className="flex justify-center items-center h-[100%] w-[33%] ">
              Role
            </div>
            {/* <div className=" flex justify-center items-center h-[100%] w-[33%]">
              Procedures{" "}
              <BsArrow90DegDown
                size={"20px"}
                className="cursor-pointer"
                onClick={() => setArrowDown(!arrowDown)}
              />
            </div> */}
          </div>

          <div className="flex flex-col ">
            {org?.users?.map((_, index) => (
              <>
                <div className="flex h-[5vh] w-full border border-black rounded-md bg-gray-100 mt-3">
                  <div
                    key={index}
                    className="flex justify-center items-center h-[100%] w-[33%] "
                  >
                    {index + 1}
                  </div>
                  <div className="flex justify-center items-center h-[100%] w-[33%]">
                    {_?.user?.firstName + ' ' + _?.user?.lastName}
                  </div>
                  <div className="flex justify-center items-center h-[100%] w-[33%]">
                    {/* {org.users[index]?.user?._role?.name} */}
                    {_?.user?._roles[0]?.role?.name || '--'}
                    {/* {console.log(org.users[index].user._role?.name)} */}
                  </div>

                  {/* <div className="flex justify-center items-center h-[100%] w-[33%]">
                    --
                  </div> */}
                  {/* <div className="flex justify-center items-center h-[100%] w-[33%]">
                    
                   
                    <select
                      onChange={async (e) => {
                        dispatch(_roleUpdateRequest());
                       const {status,data}= await api.patch(`/org/assignRoleToUser/${org._id}`, {
                          userId: _.user._id,
                          roleId: e.target.value,
                        });
                        if(status==201){
                          toast.success('Role updated.')
                          dispatch(_roleUpdateSuccess(data.updated))
                        }
                        console.log(status,data);
                      
                      }}
                      className="h-[30px] w-[10vw] border border-black"
                    >
                      {_roles.map((_, index) => (
                        <option value={_._id}>{_.name}</option>
                      ))}
                    </select>
                   
                  </div> */}
                </div>

                {arrowDown && (
                  <div className="flex flex-col h-min-[5vh] w-full border border-black rounded-md bg-gray-100">
                    {org?.users[index]?.user?._role?.procedures?.map(
                      (_pro, _index) => (
                        <div className="flex justify-center items-center h-[100%] w-[100%] gap-3 ">
                          <div className="flex justify-center items-center h-[100%] w-[50%]">
                            {_index + 1}
                          </div>
                          <div className="flex justify-center items-center h-[100%] w-[50%] ">
                            {_pro?.procedure?.name}
                            {/* <input value={`${_.user._id}-${_pro.procedure._id}`} onChange={onAssignRole} type={"checkbox"} /> */}
                          </div>
                        </div>
                      )
                    )}
                  </div>
                )}
              </>
            ))}
          </div>
        </div>
      </Modal>

      <DeleteModal
        showModal={showDeleteModal}
        setShowModal={setShowDeleteModal}
        onConfirm={confirmDelete}
      />
    </>
  );
};

export default OrganizationTable;
